var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status",class:`status--${_vm.s}`},[_c('span',{staticClass:"status_indicator"}),_c('p',[_vm._v(_vm._s(_vm.statuses[_vm.s]))])])
}
var staticRenderFns = []

export { render, staticRenderFns }